module.exports = __webpack_public_path__ + "img/meaulnes_bb_cover.b7995bf2.jpg";